<div *ngIf="adminEdit" class="container-fluid">
  <form #form="ngForm" (ngSubmit)="saveEntity(form)" class="mt-3">
    <div mat-dialog-title>
      <div *ngIf="adminEdit.id"><span i18n>Edit</span> {{pageInfo.title}}</div>
      <div *ngIf="!adminEdit.id"><span i18n>Add</span> {{pageInfo.title}}</div>
    </div>

    <div mat-dialog-content>
      <div class="mb-2">
        <span *ngIf="adminEdit.id" i18n>Make the necessary changes on the form below then click Submit</span>
        <span *ngIf="!adminEdit.id"><span i18n>To add a new</span> {{pageInfo.label}}, <span i18n>complete the form below then click Submit.</span></span>
        <span class="float-right warning col" i18n>* Required Information</span>
      </div>
      <div class="form-group mt-3">
        <span class="warning">* </span>
        <label class="col-form-label" for="name">{{pageInfo.label}}</label>
        <div class="col-sm-8">
          <input id="name" name="name" class="form-control" [(ngModel)]="adminEdit.name"
                 required #name="ngModel"
                 [class.field-error]="form.submitted && name.invalid">
          <div [hidden]="!form.submitted || name.valid"
               class="alert alert-danger">
            <span i18n>{{pageInfo.nextRoute}} is required</span>
          </div>
        </div>
      </div>
      <div *ngIf="pageInfo.nextRoute == 'account'">
        <div class="form-group form-inline">
          <span class="warning">* </span>
          <label class="col-form-label" for="stringField">{{pageInfo.label2}}</label>
          <div class="col-sm-8">
            <input id="stringField" name="stringField" class="form-control" [(ngModel)]="adminEdit.stringField"
                   required #stringField="ngModel"
                   [class.field-error]="form.submitted && stringField.invalid">
            <div [hidden]="!form.submitted || stringField.valid"
                 class="alert alert-danger">
              <span i18n>{{pageInfo.label2}} is required</span>
            </div>
          </div>
        </div>
        <div class="form-group form-inline">
          <span class="warning">* </span>
          <label class="col-form-label" for="booleanField">{{pageInfo.label3}}</label>
          <div class="col">
            <mat-radio-group name="booleanField" id="booleanField"
                             [(ngModel)]="adminEdit.booleanField"
                             required #accountTypeRadio="ngModel">
              <mat-radio-button class="mr-3" [value]="true" i18n>Income</mat-radio-button>
              <mat-radio-button [value]="false" i18n>Expense</mat-radio-button>
            </mat-radio-group>
            <div [hidden]="!form.submitted || accountTypeRadio.valid"
                 class="alert alert-danger">
              <span i18n>{{pageInfo.label3}} is required</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="pageInfo.nextRoute == 'QuoteItemNoteTemplate'">
        <div class="form-group">
          <span class="warning">* </span>
          <label class="col-form-label" for="description">{{pageInfo.label2}}</label>
          <div class="col-sm-10">
            <textarea id="description" name="description" class="form-control" [(ngModel)]="adminEdit.description"
                      required description="ngModel" maxlength="500" rows="3"
                      [class.field-error]="form.submitted && description.invalid"></textarea>

          </div>
          <div [hidden]="!form.submitted || description.valid"
               class="alert alert-danger">
            <span i18n>{{pageInfo.label2}} is required</span>
          </div>
        </div>
      </div>
      <div *ngIf="pageInfo.nextRoute == 'PaymentTerm'">
        <div class="form-group form-inline">
          <span class="warning">* </span>
          <label class="col-form-label" for="numericField">{{pageInfo.label2}}</label>
          <div class=" col-sm-8">
            <input id="numericField" name="numericField" class="form-control" type="number" min="0" [(ngModel)]="adminEdit.numericField"
                   required #numericField="ngModel"
                   [class.field-error]="form.submitted && numericField.invalid">
            <div [hidden]="!form.submitted || numericField.valid"
                 class="alert alert-danger">
              <span i18n>{{pageInfo.label2}} is required</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="pageInfo.nextRoute == 'CustomerType'">
        <div class="form-group form-inline">
          <label class="col-form-label" for="numericField">{{pageInfo.label2}}</label>
          <div class="col">
            <select [(ngModel)]="adminEdit.numericField" name="numericField" id="numericField" class="form-control select-bidit" #numericField="ngModel">
              <option [ngValue]="undefined" selected="">-</option>
              <option *ngFor="let num of numbersList;" [ngValue]="num">{{num}}%</option>
            </select>
            <div [hidden]="!form.submitted || numericField.valid"
                 class="alert alert-danger">
              <span i18n>{{pageInfo.label2}} is required</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div [hidden]="!form.submitted || form.valid"
             class="alert alert-danger" i18n>
          Validation issues encountered.  Please review your entered information.
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
      <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </form>
</div>
